import {
  AxiosError,
  AxiosInstance,
  AxiosRequestConfig,
  AxiosResponse,
} from "axios";
import { showError } from "../utils/error-handling";
import { getAxiosClient } from "./axios-client";
import SessionService from "./session-service";

const onRequest = (config: AxiosRequestConfig): AxiosRequestConfig => {
  const user = SessionService.getUser();

  if (config && config.headers) {
    if (user) {
      config.headers.Authorization = `Bearer ${user.token_dostepu}`;
    }
  }
  return config;
};

const onResponse = (response: AxiosResponse): AxiosResponse => {
  return response;
};

const onRequestError = (error: AxiosError): Promise<AxiosError> => {
  if (error.response) {
    showError(error.response);
  }
  return Promise.reject(error);
};

const onResponseError = async (error: AxiosError): Promise<AxiosError> => {
  const axiosClient = getAxiosClient();
  const originalConfig: any = error.config;
  const user = SessionService.getUser();

  if (originalConfig.url !== "/Account/Login" && error.response) {
    if (error.response.status === 401 && !originalConfig._retry) {
      originalConfig._retry = true;

      try {
        await axiosClient.ax
          .post("/Account/RefreshToken", {
            token_dostepu: user.token_dostepu,
            token_odswiezenia: user.token_odswiezenia,
          })
          .then((response) => {
            if (response.data) {
              const payload = response.data.payload;
              const updatedUser = {
                data_wygasniecia_tokenu_dostepu: payload.wygasa_token_dostepu,
                data_wygasniecia_tokenu_odswiezenia:
                  payload.wygasa_token_odswiezenia,
                token_dostepu: payload.token_dostepu,
                token_odswiezenia: payload.token_odswiezenia,
                typ_uzytkownika: user.typ_uzytkownika,
              };
              SessionService.setUser(updatedUser);
              return axiosClient.ax(originalConfig);
            }
          });
      } catch (_error: any) {
        if (
          _error.config.url === "/Account/RefreshToken" &&
          _error.response.data.error_code === 11
        ) {
          SessionService.clearUserSession();
          window.location.href = "/login";
        }
        return Promise.reject(_error);
      }
    }
  }
  if (error.response) {
    showError(error.response);
  }
  return Promise.reject(error);
};

export const setupInterceptorsTo = (
  axiosInstance: AxiosInstance
): AxiosInstance => {
  axiosInstance.interceptors.request.use(onRequest, onRequestError);
  axiosInstance.interceptors.response.use(onResponse, onResponseError);

  return axiosInstance;
};
